import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import CustomersTable from './customers-table.jsx';
import PortalAccountsTableArchived from '../portal-admin/portal-accounts-table-archived.jsx';

if (document.getElementById('react-component-g4-logistics-portal-all-archived-customers')) {
  ReactDOM.render(
    <PortalAccountsTableArchived
      url='/api/v1/portal/customers/all/archived'
      message_if_none = 'No Archived Customers found. Add one to see it here.'
    />,
    document.getElementById('react-component-g4-logistics-portal-all-archived-customers')
  );
}